<script>
import API from "@/API";
import Modal from "@/components/_Shared/Modal";
import ErrorInput from "@/components/_Shared/ErrorInput";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      display_name: "",
      state_id: "",
      code: "",
      preloader: false
    };
  },

  components: {
    Modal,
    ErrorInput
  },

  computed: {
    ...mapGetters("states", ["states"])
  },

  methods: {
    ...mapActions("states", ["listAll"]),
    ...mapActions("cities", ["create"]),
    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          await this.create({
            display_name: this.display_name,
            code: this.code,
            state_id: this.state_id
          });

          this.display_name = "";
          this.code = "";
          this.$emit("close");
          this.$emit("refresh");
        }
      } catch (error) {
        error.map(el => {
          this.$validator.errors.add(el);
        });
      }

      this.preloader = false;
    }
  },

  async mounted() {
    try {
      if (!this.states.length) await this.listAll();
    } catch (e) {
      this.$toast.error(e);
    }
  }
};
</script>

<template>
  <modal
    title="NOVA CIDADE"
    subtitle="Cadastre uma nova cidade"
    @close="$emit('close')"
  >
    <template slot="body">
      <div class="form-group">
        <div class="input-group">
          <input
            id="city_name"
            name="display_name"
            v-model="display_name"
            type="text"
            placeholder="."
            class="capitalize"
            v-validate.disable="'required'"
            data-vv-as="nome"
            :class="{ 'has-error': errors.has('display_name') }"
          />
          <label for="city_name">nome</label>
          <ErrorInput
            v-if="errors.has('display_name')"
            :message="errors.first('display_name')"
          />
        </div>

        <div class="input-group">
          <input
            id="city_code"
            name="code"
            v-model="code"
            type="text"
            placeholder="."
            class="capitalize"
            v-validate.disable="'required|max:10'"
            maxlength="10"
            data-vv-as="codigo"
            :class="{ 'has-error': errors.has('code') }"
          />
          <label for="city_code">codigo</label>
          <ErrorInput
            v-if="errors.has('code')"
            :message="errors.first('code')"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="input-group">
          <v-selectpage
            name="code"
            v-validate.disable="'required'"
            data-vv-as="estado"
            v-model="state_id"
            :data="states"
            title="Estado"
            placeholder="estado"
            key-field="id"
            show-field="name"
          ></v-selectpage>
          <ErrorInput
            v-if="errors.has('code')"
            :message="errors.first('code')"
          />
        </div>
      </div>

      <!-- <div class="title-form mt-30">DISTRITO</div>

        <div class="form-group">
            <div class="input-group">
                <input id="district_name" type="text" placeholder=".">
                <label for="district_name">distrito</label>
            </div>

            <div class="input-group">
                <input id="district_value" type="text" step=".01" min="0" placeholder=".">
                <label for="district_value">valor</label>
            </div>

            <div class="input-group">
                <input id="district_rate" type="text" step=".1" min="0" max="100" placeholder=".">
                <label for="district_rate">taxa</label>
            </div>

            <div class="input-group">
                <input id="district_start" type="text" placeholder=".">
                <label for="district_start">início</label>
            </div>

            <div class="input-group">
                <input id="district_end" type="text" placeholder=".">
                <label for="district_end">término</label>
            </div>

            <div class="input-group">
                <input id="district_rate_min" type="text" step=".1" min="0" max="5" placeholder=".">
                <label for="district_rate_min">nota min.</label>
            </div>

            <div class="input-group">
                <input id="district_rate_max" type="text" step=".1" min="0" max="5" placeholder=".">
                <label for="district_rate_max">nota max.</label>
            </div>
      </div>-->
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">
        fechar
      </button>
      <button
        class="btn bg-purple"
        :class="{ 'btn--loading': preloader }"
        @click="submit"
      >
        <span>cadastrar</span>
      </button>
    </template>
  </modal>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Cities/NewCity.vue